import { connectedStore } from '../../store';
import actions from '../actions';

const registerExtension = (extension) => {
  const store = connectedStore.get();
  store.dispatch(actions.registerExtension(extension));
};

export default registerExtension;
